import { z } from "zod";
import i18n from "../config/i18n";

import { VALIDATION } from "../config/constants";

const t = (key: string) => i18n.t(key);


// Forgot Password Schema
export const getForgotPasswordSchema = () =>
  z.object({
    email: z
      .string()
      .min(1, t("validation.emailRequired"))
      .email(t("validation.emailInvalid"))
      .regex(VALIDATION.EMAIL_REGEX, t("validation.emailInvalid")),
  });

/** @deprecated Use getForgotPasswordSchema() for i18n support */
export const forgotPasswordSchema = getForgotPasswordSchema();
export type ForgotPasswordFormData = z.infer<
  ReturnType<typeof getForgotPasswordSchema>
>;

// Reset Password Schema
export const getResetPasswordSchema = () =>
  z
    .object({
      newPassword: z
        .string()
        .min(VALIDATION.PASSWORD_MIN_LENGTH, t("validation.passwordMin")),
      confirmNewPassword: z
        .string()
        .min(1, t("validation.confirmPasswordRequired")),
    })
    .refine((data) => data.newPassword === data.confirmNewPassword, {
      message: t("validation.passwordMismatch"),
      path: ["confirmNewPassword"],
    });

/** @deprecated Use getResetPasswordSchema() for i18n support */
export const resetPasswordSchema = getResetPasswordSchema();
export type ResetPasswordFormData = z.infer<
  ReturnType<typeof getResetPasswordSchema>
>;

// Set Password Schema (for Google users)
export const getSetPasswordSchema = () =>
  z
    .object({
      newPassword: z
        .string()
        .min(VALIDATION.PASSWORD_MIN_LENGTH, t("validation.passwordMin")),
      confirmNewPassword: z
        .string()
        .min(1, t("validation.confirmPasswordRequired")),
    })
    .refine((data) => data.newPassword === data.confirmNewPassword, {
      message: t("validation.passwordMismatch"),
      path: ["confirmNewPassword"],
    });

/** @deprecated Use getSetPasswordSchema() for i18n support */
export const setPasswordSchema = getSetPasswordSchema();
export type SetPasswordFormData = z.infer<
  ReturnType<typeof getSetPasswordSchema>
>;

// Change Password Schema (for users with existing password)
export const getChangePasswordSchema = () =>
  z
    .object({
      currentPassword: z
        .string()
        .min(1, t("validation.currentPasswordRequired")),
      newPassword: z
        .string()
        .min(VALIDATION.PASSWORD_MIN_LENGTH, t("validation.passwordMin")),
      confirmNewPassword: z
        .string()
        .min(1, t("validation.confirmPasswordRequired")),
    })
    .refine((data) => data.newPassword === data.confirmNewPassword, {
      message: t("validation.passwordMismatch"),
      path: ["confirmNewPassword"],
    });

/** @deprecated Use getChangePasswordSchema() for i18n support */
export const changePasswordSchema = getChangePasswordSchema();
export type ChangePasswordFormData = z.infer<
  ReturnType<typeof getChangePasswordSchema>
>;

// Login Schema
export const getLoginSchema = () =>
  z.object({
    email: z
      .string()
      .min(1, t("validation.emailRequired"))
      .email(t("validation.emailInvalid"))
      .regex(VALIDATION.EMAIL_REGEX, t("validation.emailInvalid")),
    password: z.string().min(1, t("validation.passwordRequired")),
  });

/** @deprecated Use getLoginSchema() for i18n support */
export const loginSchema = getLoginSchema();
export type LoginFormData = z.infer<ReturnType<typeof getLoginSchema>>;
